import PrintWindow from './PrintWindow';

export default PrintWindow;